import { Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  customValidation,
  EPhone,
  formatPhoneNumber,
  getLocalValue,
  LoacalVariables,
  Method,
  validations
} from "../../../commonFunctions/CommonFunctions";
import WSPhone from "../../../Components/Phone/WSPhone";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import config from "../../../Config/clientConfig.json";

import { WSIcons } from "../../../commonFunctions/iIcons";
import { HeaderList, IHeaderListActions } from "../../../Components/Header/HeaderList";

export const Lead: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const params = useParams();
  const navigate = useNavigate();
  const id = params?.id;
  const { showMessage } = useSnackbar();
  const [loading, setLoading] = useState(false)
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false)
  const [leadStatusList, setLeadStatusList] = useState<any>([])
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // useEffect(() => {
  //   async function getLeadStatus() {
  //     const response = await callAPI('lead-status', Method.GET, null, null)
  //     if (response.length > 0) {
  //       const options: Array<any> = []
  //       response.map((item: any) => {
  //         options.push({
  //           label: item.name, value: item.id
  //         })
  //       })

  //       setLeadStatusList(options)
  //     }

  //   }
  //   getLeadStatus()
  // }, [])
  // const leadStatusSource: any = {
  //   url: "lead-status",
  //   page: 1,
  //   pageSize: 10000,
  //   filter: [],
  //   sort: [],
  // };

  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getSizeById(id: any) {
      try {
        const response: any = await callAPI("leads", Method.GET, {}, id);

        if (response && response?.data) {
          setValue("leadOwner", response.data?.leadOwner);
          setValue("leadSource", response.data?.leadSource);
          setValue("leadStatusId", response.data?.leadStatusId);
          setValue("leadStatus", response.data?.leadStatus);
          setValue("firstName", response.data?.firstName);
          setValue("lastName", response.data?.lastName);
          setValue("company", response.data?.company);
          setValue("email", response.data?.email);
          setValue("phone", response.data?.phone);
          setValue("mobile", response.data?.mobile);
          setValue("website", response.data?.website);
          setValue("industry", response.data?.industry);
          setValue("rating", response.data?.rating);
          setValue("street", response.data?.street);
          setValue("city", response.data?.city);
          setValue("state", response.data?.state);
          setValue("zipCode", response.data?.state);
          setValue("country", response.data?.country);
          setValue("remarks", response.data?.remarks);
          setValue("id", response.data?.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getSizeById(id);
    }
  }, [id, setValue]);

  // const transFormLeadStatus = (data: any) => {
  //   let leadStatus: Array<any> = [];
  //   data &&
  //     data?.map((item: any) => {
  //       leadStatus.push({ label: item.name, value: item.id });
  //     });
  //   return leadStatus;
  // };
  /**
   * Method for Add/Update the data
   * @param data
   */

  const handleData = async (data: any) => {
    try {
      const request = await saveData(data)
      setLoading(true)
      const response: any = await callAPI(
        "leads",
        Method.POST,
        request
      );

      if (response) {
        showMessage(
          response?.message,
          (response.success === true || response?.id) ? "success" : "error"
        );
        (response.success === true || response?.id) && navigate("/leads/list");
      }
    } catch (e: any) {
      showMessage(e.error);
    }
    finally {
      setLoading(false)
    }
  };
  const handleDataSaveAndNew = async (data: any) => {
    try {

      const request = await saveData(data)
      setLoadingSaveAndNew(true)
      const response: any = await callAPI(
        "leads",
        Method.POST,
        request
      );

      if (response) {
        showMessage(
          response?.message,
          (response.success === true || response?.id) ? "success" : "error"
        );
        (response.success === true || response?.id) && reset();
      }
    } catch (e: any) {
      showMessage(e.error);
    }
    finally {
      setLoadingSaveAndNew(false)
    }
  };
  const handleCancelClick = () => {
    navigate("/leads/list");
  };
  const handleUploadFile = (file: any) => {
    // setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const saveData = async (data: any) => {
    let request = {
      leadOwner: getLocalValue(LoacalVariables.UserId),
      leadSource: data?.leadSource || "",
      //  leadStatusId: data?.leadStatus || "",
      firstName: data.firstName,
      lastName: data.lastName,
      company: data?.company || "",
      email: data?.email || "",
      phone: formatPhoneNumber(data?.phone, EPhone.RemoveHyphen) || "",
      mobile: formatPhoneNumber(data?.mobile, EPhone.RemoveHyphen),
      website: data?.website || "",
      industry: data?.industry || "",
      rating: data?.rating || "",
      street: data?.street || "",
      city: data?.city || "",
      state: data?.state || "",
      zipCode: data?.zipCode || "",
      country: data?.country || "",
      remarks: data?.remarks || "",
      leadType: 0
    };
    return request
  }
  const saveFile = async (data: any) => {
    try {
      let imageName = "";
      if (data.imageUrl && data.imageUrl[0]) {
        const file = data.imageUrl[0]; // Assuming `imageUrl` contains an array of files.
        imageName = file.name; // Get the file name from the uploaded image.
      }
      const formData = new FormData()
      if (selectedFile) {
        formData.append("file", selectedFile!);
      }
      formData.append("title", data.title); // Add title
      formData.append("displayOrder", data.displayOrder); // Add display
      // const newRequest = clearRequest(request)
      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(`Bannerimg/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          response.success === true && navigate("/banner/list");
        }
        // const response: any = await callAPI(`BannerImage/${id}`, Method.PUT, request);
        // if (response) {
        //   showMessage(response?.message, response.success === true ? "success" : "error");
        //   response.success === true && navigate("/banner/list");
        // }
      } else {
        const response: any = await callAPI("Bannerimg/Create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          response.success === true && navigate("/banner/list");
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  }
  const actions: IHeaderListActions[] =
    [
      { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
      { type: 'button', text: 'Save & New', loading: loadingSaveAndNew, size: 'small', onClick: handleSubmit(handleDataSaveAndNew), buttonType: 'button', variant: 'outlined', color: 'primary' },
      { type: 'button', text: 'Save', loading: loading, size: 'small', onClick: handleSubmit(handleData), buttonType: 'submit', variant: 'outlined', color: 'primary' }
    ]
  return (
    <Grid container spacing={3} top={0}>
      {/* Left Section */}
      <Grid item xs={12} md={4}>
        {/* Top Gradient Section */}
        <Grid
          sx={{
            background: " #7D79C2",
            color: "#fff",
            padding: "2rem",
            borderBottomRightRadius: "10% ",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "10rem",
          }}
        >
          <Typography variant="h5" fontWeight="bold" sx={{ marginLeft: 10 }}>
            Create Lead
          </Typography>
          {/* <Select
            defaultValue=""
            displayEmpty
            sx={{
              bgcolor: "#fff",
              color: "#000",
              borderRadius: "5px",
              height: "40px",
              minWidth: "120px",
            }}
          >
            <MenuItem value="">Standard</MenuItem>
            <MenuItem value="Custom">Custom</MenuItem>
          </Select> */}
        </Grid>

        {/* Profile Icon */}
        <Grid display="flex" justifyContent="center" sx={{ marginTop: "-30px" }}>
          <WSIcons.AccountCircleIcon
            sx={{
              fontSize: 80,
              bgcolor: "#fff",
              borderRadius: "50%",
              padding: 1,
            }}
          />
        </Grid>

        {/* White Card Section */}
        <Card sx={{
          borderRadius: "10px",
          padding: 3,
          marginTop: "-40px",
          height: "25rem"
        }}>
          <CardContent>
            <Typography

              fontWeight="bold"
              sx={{ marginBottom: 2, fontSize: '.9rem' }}
            >
              Basic Information
            </Typography>
            <Grid container spacing={2} sx={{ marginTop: 1 }}>
              <Grid item xs={12}>
                <WSTextField
                  label={"Company"}
                  {...register("company")}
                  id="company"
                  name="company"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <WSTextField
                  label={"First Name"}
                  {...register("firstName")}
                  id="firstName"
                  name="firstName"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <WSTextField
                  label={"Last Name"}
                  {...register("lastName")}
                  id="lastName"
                  name="lastName"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <WSTextField
                  control={control}
                  className="form-control"
                  id="email"
                  {...register("email")}
                  rules={customValidation(false, validations.email)}
                  name="email"
                  label="Email"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <WSPhone
                  label={"Mobile"}
                  id={"mobile"}
                  name={"mobile"}
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>


              {/* { id && <Grid item sm={12} style={{ overflow: 'auto' }}>
                <WSFileUpload
                  name="imageUrl"
                  label="Banner Image"
                  control={control}
                  rules={{ required: false }}
                  acceptFileTypes=".jpg,.jpeg,.png"
                  maxFileSizeMB={2}
                  //  defaultValue={defaultImg}
                  id={"imageUrl"}
                  image={true}
                  onChange={handleUploadFile}
                  // onRemove={handleRemove}
                  align="Start"
                  isToolTipImg={false}
                  multiple={true}
                />
              </Grid>} */}
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* Right Section */}
      <Grid item xs={12} md={8}>
        <HeaderList title="Leads" type="card" position="relative" actions={actions} isBackButton={true} url="/leads/list" />

        <Card sx={{ borderRadius: "10px", padding: 3, position: "relative", mt: 2 }}>



          {/* Title */}
          <Typography fontWeight="bold" sx={{ marginTop: 3, fontSize: '.9rem' }}>
            Additional Information
          </Typography>

          <Grid container spacing={2} sx={{ marginTop: 1 }}>
            {/* <Grid item xs={12} sm={6}>
              <WSAutocompleteField
                label={"Lead Owner"}
                rules={{ required: true }}
                {...register("leadOwner")}
                id={"leadOwner"}
                name={"leadOwner"}
                control={control}
                options={config.customernameconfig.staticOptionData}
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <WSSelectField
                options={config.leadSourceConfig.staticOptionData}
                rules={{ required: false }}
                {...register("leadSource")}
                id="leadSource"
                control={control}
                defaultValue={""}
                label="Lead Source"
                name="leadSource"
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              {leadStatusList && (
                <WSSelectField
                  rules={{ required: false }}
                  {...register("leadStatus")}
                  id="leadStatus"
                  control={control}
                  defaultValue={'a3c5a6a7-95f6-4b74-9513-11e7269ec69c'}
                  setValue={setValue}
                  label="Lead Status"
                  name="leadStatus"
                  options={leadStatusList}
                />
              )}
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Title"}
                {...register("title")}
                id="title"
                name="title"
                control={control}
                rules={{ required: false }}
              />{" "}
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSPhone
                label={"Phone"}
                id={"phone"}
                name={"phone"}
                control={control}
                rules={{ required: false }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Fax"}
                {...register("fax")}
                id="fax"
                name="fax"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12}>
              <WSTextField
                label={"Website"}
                {...register("website")}
                id="website"
                name="website"
                control={control}
                rules={{ required: false, pattern: {
    value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/,
            message: "Please enter a valid website URL",
      } }}
              />
            </Grid>
          </Grid>
          <Typography fontWeight="bold" sx={{ marginTop: 3, fontSize: '.9rem' }}>
            Address Information
          </Typography>
          <Grid container spacing={2} sx={{ marginTop: 1 }}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Street"}
                {...register("street")}
                id="street"
                name="street"
                control={control}
                rules={{ required: false }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"City"}
                {...register("city")}
                id="city"
                name="city"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"State"}
                {...register("state")}
                id="state"
                name="state"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Zip Code"}
                {...register("zipCode")}
                id="zipCode"
                name="zipCode"
                control={control}
                rules={{ required: false }}
                maxLength={6}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Country"}
                {...register("country")}
                id="country"
                name="country"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
});
